exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".FormAddStudentRoom{width:655px}.FormAddStudentRoom label{font-size:17px;color:#a8a8a8;font-weight:700}.FormAddStudentRoom .ant-radio-wrapper{width:100%;font-size:17px;color:#a8a8a8;font-weight:400;margin-bottom:10px}.FormAddStudentRoom textarea{background-color:#f1f1f1;color:#4a4a4a;width:100%;padding:10px}.FormAddStudentRoom .message-info{margin-bottom:20px;color:#28a745;font-size:16px;display:flex;align-items:center}.FormAddStudentRoom .message-info.confirm{margin:40px 0}.FormAddStudentRoom .message-info .anticon{font-size:40px;margin-right:10px}.FormAddStudentRoom .message-warning{margin-bottom:60px;margin-top:40px;color:#dc3545;font-size:16px;display:flex;align-items:center}.FormAddStudentRoom .message-warning.confirm{margin:40px 0}.FormAddStudentRoom .message-warning .anticon{font-size:40px;margin-right:10px}.FormAddStudentRoom p{margin-top:10px}.FormAddStudentRoom .error{color:red}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./yii2/frontend/frontend-assets/src/components/RoomsAndStudents/Students/components/FormAddStudentRoom/style.scss
// module id = 4928
// module chunks = 0